import { render, staticRenderFns } from "./face-input.vue?vue&type=template&id=a4067742&scoped=true&"
import script from "./face-input.vue?vue&type=script&lang=js&"
export * from "./face-input.vue?vue&type=script&lang=js&"
import style0 from "./face-input.vue?vue&type=style&index=0&id=a4067742&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4067742",
  null
  
)

export default component.exports